/* tslint:disable */
/* eslint-disable */
export enum FluencyRateTimerMode {
  FixedDuration = 1,
  OpenEnded = 2
}
